/* eslint 'array-callback-return': 'off','no-array-constructor': 'off', eqeqeq: 'off'  */
import React, { Component } from 'react';
import { Table, Button, FormGroup, Modal,Col } from 'reactstrap';
import { connect } from "react-redux";
import ErrorGif from '../../../../../Assets/images/Error.gif';
import classnames from 'classnames';
import '../../../../../Assets/EnsembleStyles/ChangeLimits.css';
import ChangeLimits from '../_ModalsForms/ChangeLimits';
import { GetTemperatureAdjustmentsList,PostEnableDisableTempAdjustments } from '../../../../../action/temperatureAdjustmentsAction';
import * as ErrorMessage from '../../../../../Resources/ErrorMessages';
import SelectAllCheckboxes from '../../../../../Resources/SelectAllCheckboxes';
import DMResources from '../../../../../Resources/DMResources.en-US';
import SearchInput, {createFilter} from 'react-search-input';


const KEYS_TO_FILTERS = ['maximumSetting','zoneName','buildingName','minimumSetting','members.objectName'];

class TemperatureAdjustments extends Component {

    componentWillMount() {
        this.props.GetTemperatureAdjustmentsList();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props != nextProps) {
            this.setState({ temp_adjustments_list_state: nextProps.tempAdjustment_response, IsChangesSaved: true });
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            temp_adjustments_list_state: this.props.tempAdjustment_response,
            modal: false,
            confirmation_modal: false,
            error_msg: false,
            records_selected : new Array(),
            changelimits_records: [],
            indColumnSearch:false,
            searchTerm: '',
            sort: {
                column: 'buildingName',
                direction:[
                    {name:'buildingName', direction:'asc', onclick:true},
                    {name:'members', direction:'desc', onclick:false},
                    {name:'zoneName', direction:'desc', onclick:false},
                    {name:'minimumSetting', direction:'desc', onclick:false},
                    {name:'maximumSetting', direction:'desc', onclick:false},
                ]
              },
            IsDefaultSort: true,
        };
        this.toggle = this.toggle.bind(this);
        this.confirmationtoggle = this.confirmationtoggle.bind(this);
        this.searchUpdated = this.searchUpdated.bind(this);
        
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }
    confirmationtoggle() {
        this.setState({
            confirmation_modal: !this.state.confirmation_modal
        });
    }



/* Enable Disable Function*/

    EnableDisable(value) {
        let Data,selectedRecords = null;
        this.setState({ error_msg: false });
        selectedRecords =this.state.records_selected;

        var checkboxes = document.getElementsByClassName('temp_adjustments_records');
        for (var i = 0; i < checkboxes.length; i++) {
          if  (checkboxes[i].checked === true) {
              var temp_adjustments_records_EnableDisable = {
                  "zoneId" : checkboxes[i].id 
              }
              selectedRecords.push(temp_adjustments_records_EnableDisable);
          } 
         }

        if (selectedRecords.length > 0) {
            Data = { "zones": selectedRecords, "enableAdjustment": value }
            this.props.PostEnableDisableTempAdjustments(Data);
            this.setState({ error_msg: false });
        }
        else {
            this.setState({ error_msg: true });
        }
        this.setState({ records_selected: new Array() });
    }


/* Enable Disable Function*/

ChangeLimits() {
    
    let changelimits_selectedRecords = null;
    this.setState({ error_msg: false });
    this.setState({ changelimits_records: [] },()=>{
        changelimits_selectedRecords = this.state.changelimits_records;

        var checkboxes = document.getElementsByClassName('temp_adjustments_records');
        for (var i = 0; i < checkboxes.length; i++) {
          if  (checkboxes[i].checked === true) {
              var temp_adjustments_records_EnableDisable = {
                  "zoneId" : checkboxes[i].id 
              }
              changelimits_selectedRecords.push(temp_adjustments_records_EnableDisable);
          } 
         }
    
         this.setState({ changelimits_records: changelimits_selectedRecords });
         console.log(this.state.changelimits_records);
    
    
        if (changelimits_selectedRecords.length > 0) {
            let count = 0;
        var testdata = this.state.temp_adjustments_list_state; 
        //eslint-disable-next-line no-unused-vars
            var task_names = testdata.map(function (task, index, array) {
                changelimits_selectedRecords.map(function (task2, index, array) {
                    if(task.zoneId ==task2.zoneId){
                        if(task.isEnabled ==false){
                            count++;
                        }
                    }
                });
            });
    
            if(count!=0){
                this.confirmationtoggle();
            }
            else{
            this.toggle();
            }
        }
        else {
            this.setState({ error_msg: true });
        }
    });
   

}

cancelConfirmation(){
    this.confirmationtoggle();
}

 changeLimitsPost(){
    this.confirmationtoggle();
    console.log(this.state.changelimits_records);
    this.toggle();
}


/* Sorting System */

onSort = (column) => (e) => {
    this.setState({IsDefaultSort:false});
    var SortData = this.state.sort.direction;
    var selected = SortData.filter(a => a.name == column);
    const direction = selected[0] ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
    var notequals = 0;
    var data_from_state = this.state.temp_adjustments_list_state;
    if(data_from_state != null){
    const sortedData = this.state.temp_adjustments_list_state.sort((a, b) => {

        const nameA = (column == 'members') ? a[column].map(xl =>(xl.objectName)).join(', ').toLowerCase() : a[column].toLowerCase();
        const nameB = (column == 'members') ? b[column].map(xl =>(xl.objectName)).join(', ').toLowerCase() : b[column].toLowerCase();
        if (nameA < nameB) {
            notequals = 1;
            return -1;
        }
        if (nameA > nameB) {
            notequals = 1;
            return 1;
        }
        if (nameA == nameB) {
            return 0;
        }
        return 0;
    });

    if(selected[0].direction =='asc' && notequals == 1){
    sortedData.reverse(); 
   }
 
   SortData.map(x => (x.name !== column) ? x.onclick = false : x.onclick = true);
   SortData.map(x => (x.name !== column) ? x.direction = SortData.filter(m => (m.name === x.name))[0].direction : x.direction = direction);

    this.setState({
        temp_adjustments_list_state: sortedData,
      sort: {
        column,
        direction : SortData,
      }
    });
    }
  };

  setArrow = (column) => {
    let className = 'workorder-sort-direction';
    let sortColumn = this.state.sort.direction.filter(x => (x.name === column))[0];
    className += (sortColumn.onclick === true) ? (sortColumn.direction === 'asc') ? ' asccolor' : ' desccolor' : ' desc';
    return className;
  };

    render(getLabels,UserCanEdit) {
        let data, temperatureAdjustments, Error_Message,FilteredData,lUserCanEdit;
        let label = this.props.getLabels;

        lUserCanEdit = this.props.UserCanEdit;
        lUserCanEdit = lUserCanEdit !== undefined && lUserCanEdit !== null && lUserCanEdit ? true : false;

        if (this.state.temp_adjustments_list_state != null && this.state.temp_adjustments_list_state != undefined && this.state.temp_adjustments_list_state.length > 0 ) {
            data = this.state.temp_adjustments_list_state;
            if(this.state.IsDefaultSort){
                data.sort((a,b)=>{
                    let nameA = a['buildingName'].toLowerCase();
                    let nameB = b['buildingName'].toLowerCase();
                    if(nameA < nameB){
                        return -1;
                    }
                    if(nameA > nameB){
                        return 1;
                    }
                    if(nameA == nameB){
                        return 0;
                    }
                    return 0;
                });
            }
            if(this.state.IsChangesSaved){
                data.sort((a,b) => {
                    let nameA = (this.state.sort.column == 'members') ? a[this.state.sort.column].map(xl =>(xl.objectName)).join(', ').toLowerCase() : a[this.state.sort.column].toLowerCase();
                    let nameB = (this.state.sort.column == 'members') ? b[this.state.sort.column].map(xl =>(xl.objectName)).join(', ').toLowerCase() : b[this.state.sort.column].toLowerCase();
                    if(nameA < nameB){
                        return -1;
                    }
                    if(nameA > nameB){
                        return 1;
                    }
                    if(nameA == nameB){
                        return 0;
                    }
                    return 0;
                });
                if(this.state.sort.direction.filter(x => x.name === this.state.sort.column)[0].direction === "desc"){
                    data.reverse();
                }
                this.setState({IsChangesSaved: false});
            }
            FilteredData = data.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));

            if(FilteredData.length !=0){
                let Unit = DMResources.FamilyList('Enum3046.120.Text');
                temperatureAdjustments = FilteredData.map(el => (
                    <tr id={el.zoneId}  key={el.zoneId}>
                        <td><input type="checkbox" id={el.zoneId} className="temp_adjustments_records" /></td>
                        <td>{el.buildingName}</td>
                        <td> { el.members.map(xl =>(xl.objectName)).join(', ')}</td>
                        <td>{el.zoneName}</td>
                     <td>   {(el.isEnabled==false ? label['TemperatureAdjustment.Disable.Text'] : (el.minimumSetting + ' ' +Unit) )}</td>
                     <td>   {(el.isEnabled==false ? label['TemperatureAdjustment.Disable.Text']: (el.maximumSetting + ' ' +Unit) )}</td></tr>
                ));
            }
            else {
                temperatureAdjustments = <tr><td colSpan="6">{label['NoRecords.Text']}</td></tr>
            }
    
    }
        else {
            temperatureAdjustments = <tr><td colSpan="6">{label['NoRecords.Text']}</td></tr>
        }

        (this.state.error_msg == true) ? Error_Message = <p className="error_msg"> <img src={ErrorGif} alt="Trane Logo" />  {ErrorMessage.selection_error}</p> : Error_Message = " ";


        return (
          <div className="tenant_content_border"> 
            <div className="main_container">

                {Error_Message}

                {/* Options group */}
                <div className="buttons_container">
                    <Button type="button" hidden={!lUserCanEdit} className="btn btn-black" style={{width:'140px',height:'40px',fontSize:'12px'}} onClick={()=>this.EnableDisable(false)}>{label['Requests.btnDisable.Text']} </Button>
                    <Button type="button" hidden={!lUserCanEdit} className="btn btn-black" style={{height:'40px',fontSize:'12px'}} onClick={()=>this.EnableDisable(true)}>{label['Requests.btnEnable.Text']}  </Button>
                    <Button type="button" hidden={!lUserCanEdit} className="btn btn-black" style={{width:'140px',height:'40px',fontSize:'12px'}} onClick={()=>this.ChangeLimits()}>{label['Requests.btnChangeLimit.Text']}</Button>
                    <SearchInput className="search-input" onChange={this.searchUpdated} />
                </div> <br />


                {/* Table Container */}

                <div className="table_container">
                    <Table striped responsive className=" Custom_table table_border">
                        <tbody className="cell_container tenant_cell">
                            <tr>
                                <th><input type="checkbox" className="header_Check_box" onClick={() => { SelectAllCheckboxes.selectAllCheckbox("temp_adjustments_records", "header_Check_box"); }} /></th>
                                <th onClick={this.onSort('buildingName')}  className="link_cursor"> {label['SubGroups.Columns.SiteName.Text'] !== undefined ? label['SubGroups.Columns.SiteName.Text'] : "Building"} <span className={this.setArrow('buildingName')}></span> </th>
                                <th onClick={this.onSort('members')}  className="link_cursor"> {label['SubGroups.Columns.Members.Text'] !== undefined ? label['SubGroups.Columns.Members.Text'] : "Members"} <span className={this.setArrow('members')}></span> </th>
                                <th onClick={this.onSort('zoneName')}  className="link_cursor">  {label['EnumTESBuildingSubgroup.cboForColumn.zone.Text'] !== undefined ? label['EnumTESBuildingSubgroup.cboForColumn.zone.Text'] : "Zone"} <span className={this.setArrow('zoneName')}></span> </th>
                                <th onClick={this.onSort('minimumSetting')}  className="link_cursor"> {label['TemperatureAdjustment.Columns.Minimum.Text'] !== undefined ? label['TemperatureAdjustment.Columns.Minimum.Text'] : "Minimum Temperature Setting"} <span className={this.setArrow('minimumSetting')}></span> </th>
                                <th onClick={this.onSort('maximumSetting')}  className="link_cursor">  {label['TemperatureAdjustment.Columns.Maximum.Text'] !== undefined ? label['TemperatureAdjustment.Columns.Maximum.Text'] : "Maximum Temperature Setting"} <span className={this.setArrow('maximumSetting')}></span> </th>
                              
                            </tr>
                          
                            {temperatureAdjustments}
                        </tbody>
                    </Table>
                </div>
                <Modal isOpen={this.state.modal} toggle={this.toggle} className={classnames({ classnames: this.props.className }, "ChangeLimts_ModalContainer ")} >
                    <ChangeLimits  parentToChildData={this.state.changelimits_records}  toggle={this.toggle} />
                </Modal>


                <Modal isOpen={this.state.confirmation_modal} confirmationtoggle={this.confirmationtoggle} className={classnames({ classnames: this.props.className }, "ChangeLimts_ModalContainer ")} >
                    <div className="ChangeLimits_Modal">
                        <p className="error_msg">
                        {label['TemperatureAdjustment.ConfirmMessage.Text'] !== undefined ? label['TemperatureAdjustment.ConfirmMessage.Text'] : "One or more selected zones has temperature adjustment disabled. Do you want to enable temperature adjustment on all selected zones?"}
                        </p>

                        <FormGroup row >
                            <Col sm={{ size: 12 }}>
                                <Button className="btn-gray btn-md ChangeLimits_Applybtn" onClick={()=>this.cancelConfirmation()}>{label['ManageTenants.No.Text'] !== undefined ? label['ManageTenants.No.Text'] : "No"}</Button>
                                <Button className="btn-success btn-md ChangeLimits_Cancelbtn" onClick={()=> this.changeLimitsPost()}>{label['TenantConsumption.Yes.Text'] !== undefined ? label['TenantConsumption.Yes.Text'] : "Yes, Delete"} </Button>

                            </Col>
                        </FormGroup>
                    </div>
                </Modal>

             </div>
            </div>
        );
    }


searchUpdated (term) {
    this.setState({searchTerm: term})
  }
}


const mapStateToProps = state => {
    return {
        tempAdjustment_response: state.TempAdjustmentsRootReducer.TempAdjustmentsList,
        getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference,
        UserCanEdit: state.authService.HasApplicationFullAcess
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetTemperatureAdjustmentsList: () => dispatch(GetTemperatureAdjustmentsList()),
        PostEnableDisableTempAdjustments: (data) => dispatch(PostEnableDisableTempAdjustments(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TemperatureAdjustments);


